import { CATEGORY_LAYOUT_CHANGED } from '../actions/category';

export default (state, action) => {
  if (!state) {
    return {
      id: null,
    };
  }

  switch (action.type) {
    case CATEGORY_LAYOUT_CHANGED: {
      return {
        ...state,
        mode: action.mode,
      };
    }

    case 'SESSION_RECEIVE': {
      return {
        ...state,
        mode: action.session.categoryLayout || state.mode,
      };
    }

    default:
  }

  return state;
};
